document.querySelector('.contact__button button').addEventListener("click", function(event){
     event.preventDefault();
     if(document.querySelector('.terms-conditions input').checked){
        document.querySelector('.checked-error-message').style.display = 'none';
        document.querySelector('#ContactForm').submit();
     }else{
           document.querySelector('.checked-error-message').style.display = 'block';

     }
});
document.addEventListener("DOMContentLoaded", function() {
  if (window.location.href.indexOf('?contact_posted=true') !== -1) {
    const contactForm = document.getElementById('ContactForm');
    const header = document.querySelector('.header-wrapper');
    if (contactForm) {
      const headerHeight = header ? header.offsetHeight : 0;
      const elementPosition = contactForm.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - headerHeight - 20;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  }
});

